module.exports = __webpack_public_path__ + "img/scenarios-de-missions-lazy.b2a2bfa7.jpg";